  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('.carousel');

    carousels.forEach(function(carousel) {
      var flkty = Flickity.data(carousel);

      if (flkty) {
        // Perform the check immediately after initialization
        if (flkty.cells.length <= 1) {
          // Hide navigation buttons
          var buttons = carousel.querySelectorAll('.flickity-prev-next-button');
          buttons.forEach(function(button) {
            button.style.display = 'none';
          });
        }
      }
    });
  });